import { api, apiV2, unwrap } from "../utils/apiClient";
import { endpoints, endpointsV2 } from "../utils/constants";

// ——— Auth ———
export const loginPassword = (payload) =>
  api.post(endpoints.login, payload, { skipAuth: true }).then(unwrap);

export const loginOtp = (payload) =>
  apiV2.post(endpointsV2.login, payload, { skipAuth: true }).then(unwrap);

export const verifyOtpV2 = (payload) =>
  apiV2
    .post(endpointsV2.verifyOtpV2, payload, { skipAuth: true })
    .then(unwrap);

export const logoutApi = () =>
  api.post(endpoints.logout, {}, { requireUser: true }).then(unwrap);

export const forgotPassword = (payload) =>
  api.post(endpoints.forgotPassword, payload, { skipAuth: true }).then(unwrap);

export const resetPassword = (payload) =>
  api.put(endpoints.resetPassword, payload, { skipAuth: true }).then(unwrap);

export const resendOtp = (payload) =>
  api.post(endpoints.resendOtp, payload, { skipAuth: true }).then(unwrap);

export const signup = (payload) =>
  api.post(endpoints.signup, payload, { skipAuth: true }).then(unwrap);

export const verifyForgotOtp = (payload) =>
  api.put(endpoints.verifyOtp, payload, { skipAuth: true }).then(unwrap);

export const getProfile = () =>
  api.get(endpoints.getProfile, { requireUser: true }).then(unwrap);

export const updateProfile = (payload) =>
  api
    .put(endpoints.updateProfile, payload, { requireUser: true })
    .then(unwrap);

export const getAppVersions = () =>
  api.get(endpoints.getAppVersions, { skipAuth: true }).then(unwrap);

// ——— Catalog ———
export const fetchHome = () => api.get(endpoints.home).then(unwrap);

export const fetchCategoryTests = (categoryId) =>
  api
    .get(endpoints.getCategoryTests, { params: { categoryId } })
    .then(unwrap);

export const fetchAllTests = (categoryId) =>
  api
    .get(endpoints.getAllTests, {
      params: categoryId ? { categoryId } : undefined,
    })
    .then(unwrap);

export const fetchPackageDetails = (packageId) =>
  api
    .get(endpoints.getPackageDetails, { params: { packageId } })
    .then(unwrap);

// ——— Booking & payments ———
export const createBooking = (payload) =>
  api.post(endpoints.booking, payload, { requireUser: true }).then(unwrap);

export const createRazorpayOrder = (amount, currency = "INR") =>
  api
    .get(endpoints.createRazorpayOrder, {
      params: { amount, currency },
      requireUser: true,
    })
    .then(unwrap);

export const fetchMyBookings = () =>
  api.get(endpoints.myBookings, { requireUser: true }).then(unwrap);

export const fetchMyBookingDetails = (bookingId) =>
  api
    .get(endpoints.myBookingDetails, {
      params: { bookingId },
      requireUser: true,
    })
    .then(unwrap);

export const rescheduleOrCancelBooking = (payload) =>
  api
    .put(endpoints.rescheduleOrCancelBooking, payload, { requireUser: true })
    .then(unwrap);

export const fetchMyReports = () =>
  api.get(endpoints.myReports, { requireUser: true }).then(unwrap);

// ——— Coupons ———
export const fetchCoupons = () =>
  api.get(endpoints.getCoupons, { requireUser: true }).then(unwrap);

/** Match coupon from list (browser-safe). API checkCoupon is GET+body and often fails in browsers. */
export const checkCoupon = async (name) => {
  const code = String(name || "").trim();
  if (!code) {
    return { status: 0, message: "Enter coupon code", data: null };
  }

  // Prefer local active coupons from getCoupons (reliable in browser)
  try {
    const listRes = await fetchCoupons();
    const list = Array.isArray(listRes?.data) ? listRes.data : [];
    const found = list.find(
      (c) =>
        String(c?.name || "").toLowerCase() === code.toLowerCase() &&
        Number(c?.isActive) === 1 &&
        Number(c?.isDeleted) !== 1
    );
    if (found) {
      return { status: 1, message: "success", data: found };
    }
  } catch (_) {
    // fall through to API attempt
  }

  // Backend currently reads body on GET; keep as secondary attempt
  try {
    const res = await api.get(endpoints.checkCoupon, {
      data: { name: code },
      requireUser: true,
    });
    return unwrap(res);
  } catch (err) {
    return { status: 0, message: err.message || "Invalid coupon", data: null };
  }
};

// ——— Addresses ———
export const fetchAddresses = () =>
  api.get(endpoints.getAddresses, { requireUser: true }).then(unwrap);

export const addAddress = (payload) =>
  api.post(endpoints.addAddress, payload, { requireUser: true }).then(unwrap);

export const updateAddress = (payload) =>
  api
    .put(endpoints.updateAddress, payload, { requireUser: true })
    .then(unwrap);

export const deleteAddress = (addressId) =>
  api
    .put(endpoints.deleteAddress, { addressId }, { requireUser: true })
    .then(unwrap);

// ——— Feedback & contact ———
export const submitFeedback = (payload) =>
  api
    .post(endpoints.submitFeedback, payload, { requireUser: true })
    .then(unwrap);

export const contactUsApi = (payload) =>
  api.post(endpoints.contactUs, payload, { requireUser: true }).then(unwrap);

export const websiteFeedback = (payload) =>
  api
    .post(endpoints.websiteFeedback, payload, { skipAuth: true })
    .then(unwrap);

export const fetchBlogs = () =>
  api.get(endpoints.blogs, { skipAuth: true }).then(unwrap);
